/* AI-media note (EU AI Act Art. 50, Felix 15.10.2026): the product pages' note "Bild mit KI-Unterstützung
   erstellt" on every other AI picture and clip of goessl.com - banners, Journal pictures, gallery frames, video
   tiles. The list comes from the shop metafield goessl.ai_media (snippets/ai-media-note.liquid): file names as
   Shopify serves them, and Shopify video ids. Every <img> and <video> on the page is matched by its served URL,
   including the ones the galleries and lightboxes build later (MutationObserver), so a picture is labelled
   wherever it is shown and no section has to know about it.
   Each labelled element also carries a machine-readable marker (data-digital-source-type, the IPTC term the
   product pages use in their JSON-LD), and the page gets one JSON-LD list of its AI media.
   Product cards (23.10.2026): the card's picture frame lists its product's AI picture files (data-ai-media-files from
   the product metafield goessl.ai_media - snippets/card-product.liquid, the wishlist), so a card picture is labelled
   while it shows one of them, through every swatch and hover swap.
   Tone (SJ 25.10.2026: "only white text (no outline) on dark closeup photos. Otherwise black text (no outline)."): a
   note is ink unless the picture it sits on is on the shop's dark list - "dark" for notes in a picture's corner,
   "darkCard" for the notes beside a product card's quick-view eye - and white then (data-on-dark). A letterboxed
   picture that leaves the note on its frame's light band keeps the ink.
   Pixels (team lead 25.10.2026): the list only paints the first tone. Once the page has loaded, every note - these,
   the product page's and the quick view's - reads the picture under it in the crop that is actually shown (through
   swaps and resizes) and keeps or corrects its tone: white where clearly more of the pixels under its box (half again
   as many) leave white letters at 4.5:1 than ink ones, else ink. A read draws the picture the browser already holds (no
   download) through a canvas the size of the note, in idle time after the load event. A scrim the theme lays over the
   picture counts as the screen shows it (one that paints over the note dims its letters too), and one dark enough to
   leave white letters at 4.5:1 over any picture (the column heroes' corner) sets white at once, without the list or a
   read. A read that cannot happen - a clip, a picture still loading, a tainted or blocked canvas, a note not wholly on
   the picture, a scrim it cannot work out - changes nothing. */
(function () {
  'use strict';
  var data = document.getElementById('g26-ai-media');
  if (!data) return;
  var cfg;
  try { cfg = JSON.parse(data.textContent); } catch (e) { return; }
  var set = function (list) { var o = {}; String(list || '').split('|').forEach(function (k) { if (k) o[k] = true; }); return o; };
  var KEYS = set(cfg.keys);
  // the AI pictures that are dark where the note sits: in their corner, and beside a product card's quick-view eye
  var DARK = set(cfg.dark), DARK_CARD = set(cfg.darkCard);
  // The snippet renders the note with `| t | json`, and t HTML-escapes it; the label sets it as textContent, so the
  // entities go back to characters here, as in window.g26tText ("dell&#39;IA" showed on /it, 21.10.2026).
  var unescape = function (t) {
    return String(t).replace(/&(amp|lt|gt|quot|#39);/g, function (m, e) { return { amp: '&', lt: '<', gt: '>', quot: '"', '#39': "'" }[e]; });
  };
  var NOTE = unescape(cfg.note || 'Bild mit KI-Unterstützung erstellt');
  // 22.10.2026 (SJ: "minimize it a bit further"): the picture shows the short word, the full sentence stays for screen readers
  var SHORT = unescape(cfg.short || 'KI-Bild');
  var IPTC = 'https://cv.iptc.org/newscodes/digitalsourcetype/trainedAlgorithmicMedia';
  var VIDEO_ID = /\/videos\/c\/vp\/([0-9a-f]{32})\//;
  // legacy size suffixes of img_url / file_img_url: name_400x.jpg, name_400x600_crop_center@2x.jpg
  var SIZE_SUFFIX = /_(?:\d+x\d*|\d*x\d+)(?:_crop_[a-z]+)?(?:@\dx)?(?=\.[a-z0-9]+$)/i;
  // product pages label their own images (product metafield goessl.ai_media)
  var OWN_NOTE = '.g26-pdp__slide--ai, .goessl-lightbox__slide--ai, .quick-view__gallery-slide--ai';
  // their notes on the picture (the lightbox's caption sits below it): toned here from the pixels, see below
  var SLIDE_NOTE = '.g26-pdp__ai-note, .quick-view__ai-note';
  // a product card's picture frame, with the file names of its product's AI pictures (|-separated)
  var CARD_FRAME = '[data-ai-media-files]';

  // the list entry a URL stands for: the Shopify video id, or the file name without query and size suffix
  function keyOf(url) {
    if (!url || url.indexOf('data:') === 0 || url.indexOf('blob:') === 0) return null;
    var path;
    try { path = new URL(url, location.href).pathname; } catch (e) { return null; }
    var v = path.match(VIDEO_ID);
    if (v) return v[1];
    var name = path.split('/').pop() || '';
    try { name = decodeURIComponent(name); } catch (e) { /* keep it encoded */ }
    return name.replace(SIZE_SUFFIX, '');
  }

  // the URLs an element shows: what the browser picked if it has picked, otherwise every candidate
  function urlsOf(el) {
    var out = [];
    var add = function (u) { if (u) out.push(u); };
    var addSet = function (s) { String(s || '').split(',').forEach(function (part) { add(part.trim().split(/\s+/)[0]); }); };
    if (el.tagName === 'IMG') {
      if (el.currentSrc) return [el.currentSrc];
      add(el.getAttribute('src')); add(el.getAttribute('data-src'));
      addSet(el.getAttribute('srcset')); addSet(el.getAttribute('data-srcset'));
      if (el.parentElement && el.parentElement.tagName === 'PICTURE') {
        el.parentElement.querySelectorAll('source').forEach(function (s) { addSet(s.getAttribute('srcset')); });
      }
    } else {
      add(el.currentSrc); add(el.getAttribute('src')); add(el.getAttribute('data-src'));
      el.querySelectorAll('source').forEach(function (s) { add(s.getAttribute('src')); add(s.getAttribute('data-src')); });
      add(el.getAttribute('poster'));   // a clip's poster is one of its frames
    }
    return out;
  }
  function aiKeyOf(el) {
    var urls = urlsOf(el);
    var card = el.closest(CARD_FRAME);
    var own = card ? '|' + card.getAttribute('data-ai-media-files') + '|' : '';
    for (var i = 0; i < urls.length; i++) {
      var k = keyOf(urls[i]);
      if (k && (KEYS[k] || own.indexOf('|' + k + '|') > -1)) return k;
    }
    return null;
  }

  /* ---------- placement ---------- */
  function sameBox(a, b) {
    return Math.abs(a.left - b.left) < 2 && Math.abs(a.top - b.top) < 2 &&
      Math.abs(a.width - b.width) < 2 && Math.abs(a.height - b.height) < 2;
  }
  // the innermost block-level ancestor that is exactly the picture's box (a tile, a hero frame) - the label sits inside
  function frameOf(el, r) {
    var a = el.parentElement;
    for (var i = 0; a && i < 4; i++, a = a.parentElement) {
      if (!sameBox(r, a.getBoundingClientRect())) return null;
      var d = getComputedStyle(a).display;
      if (d !== 'inline' && d !== 'contents') return a;
    }
    return null;
  }
  // the nearest block-level ancestor, for a picture smaller than its box (rich text, a lightbox stage)
  function anchorOf(el) {
    var a = el.parentElement;
    if (a && a.tagName === 'PICTURE') a = a.parentElement;
    while (a && a !== document.body && /^(inline|contents)$/.test(getComputedStyle(a).display)) a = a.parentElement;
    return a;
  }
  // a static box may become relative only if no absolutely positioned child currently hangs on an outer block
  function positionable(box) {
    if (getComputedStyle(box).position !== 'static') return true;
    var all = box.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      if (getComputedStyle(all[i]).position === 'absolute' && all[i].offsetParent && !box.contains(all[i].offsetParent)) return false;
    }
    return true;
  }
  // the picture's visible rectangle (object-fit: contain letterboxes it inside the element)
  function pictureBox(el, r) {
    var nw = el.naturalWidth || el.videoWidth, nh = el.naturalHeight || el.videoHeight;
    if (!nw || !nh || getComputedStyle(el).objectFit !== 'contain') return r;
    var s = Math.min(r.width / nw, r.height / nh), w = nw * s, h = nh * s;
    return { left: r.left + (r.width - w) / 2, top: r.top + (r.height - h) / 2, width: w, height: h, right: r.left + (r.width + w) / 2, bottom: r.top + (r.height + h) / 2 };
  }
  function sizeOf(w) { return w < 240 ? 's' : w < 600 ? 'm' : 'l'; }
  // a cloned label has no owner (JS properties do not survive cloneNode); labels of other pictures stay
  function dropCopies(nodes, keep) {
    Array.prototype.slice.call(nodes).forEach(function (n) {
      if (n && n !== keep && !n.__g26Owner && n.classList && n.classList.contains('g26-ai-note')) n.remove();
    });
  }

  // the first paint: white letters only where a dark-listed picture really lies under the note (its box inside the
  // picture's box); the picture's own pixels have the last word (below)
  function tone(el) {
    var note = el.__g26AiNote, key = el.getAttribute('data-ai-media-key');
    if (!note || !note.isConnected || !key) return;
    var n = note.getBoundingClientRect(), fixed = scrimTone(scrimOver(el, note, n));
    if (fixed) { setTone(note, fixed); return; }   // a scrim that decides alone: from the first paint, without a read
    var px = note.__g26Px || {}, known = px[sigOf(el, n)];
    if (known) { px.last = srcOf(el); setTone(note, known); return; }   // this picture in this crop has been read
    if (px.last !== srcOf(el)) {   // a picture not read yet: the list paints it (the same one in a new crop keeps its tone)
      var card = el.closest(CARD_FRAME);
      var list = card && card.querySelector('.goessl-product-card__quick-view') ? DARK_CARD : DARK;
      var dark = false;
      if (list[key]) {
        var r = el.getBoundingClientRect(), pic = pictureBox(el, r);
        dark = r.width > 0 && n.width > 0 && n.left >= pic.left - 1 && n.right <= pic.left + pic.width + 1 &&
          n.top >= pic.top - 1 && n.bottom <= pic.top + pic.height + 1;
      }
      setTone(note, dark ? 'white' : 'ink');
    }
    readSoon(note);
  }

  /* ---------- the tone from the pixels under the note ---------- */
  // the letters are white or ink (#1a1a1a); an sRGB channel value in linear light, worked out once
  var INK = 26, LIN = [];
  for (var c = 0; c < 256; c++) LIN.push(c <= 10 ? c / 255 / 12.92 : Math.pow((c / 255 + 0.055) / 1.055, 2.4));
  function srcOf(img) { return img.currentSrc || img.getAttribute('src') || ''; }
  // a note's state on its picture: what the picture shows, where the note sits on it, how large it is shown
  function sigOf(img, n) {
    var r = img.getBoundingClientRect();
    return srcOf(img) + '|' + Math.round(n.left - r.left) + ',' + Math.round(n.top - r.top) + '|' + Math.round(r.width) + 'x' + Math.round(r.height);
  }
  function setTone(note, t) { if (t === 'white') note.setAttribute('data-on-dark', ''); else note.removeAttribute('data-on-dark'); }
  // a label's own picture, or the picture of the product page / quick-view slide the note sits in
  function pictureOf(note) { return note.__g26Owner || (note.parentElement && note.parentElement.querySelector('img')); }
  // where the shown picture lies relative to the note's box - its fitted box (object-fit, object-position) in CSS px from
  // the note's top-left corner - and the size of the read (the note's own, at most 64 x 24, the picture scaled with
  // it); null when the note is not wholly on the picture (a letterbox band). CSS px on purpose: the browsers disagree
  // about the pixels of a srcset picture (naturalWidth is density-corrected, a drawImage source rectangle is not), and
  // a destination rectangle means the same in all of them.
  function regionOf(img, n) {
    var r = img.getBoundingClientRect(), nw = img.naturalWidth, nh = img.naturalHeight;
    if (!r.width || !r.height || !nw || !nh) return null;
    var cs = getComputedStyle(img), fit = cs.objectFit, kx = r.width / nw, ky = r.height / nh;
    if (fit === 'cover') kx = ky = Math.max(kx, ky);
    else if (fit === 'contain' || fit === 'scale-down') kx = ky = Math.min(kx, ky, fit === 'scale-down' ? 1 : Infinity);
    else if (fit === 'none') kx = ky = 1;
    var w = nw * kx, h = nh * ky, pos = String(cs.objectPosition || '50% 50%').split(' ');
    var at = function (p, free) { return /%$/.test(p) ? free * parseFloat(p) / 100 : parseFloat(p) || 0; };
    var left = r.left + at(pos[0] || '50%', r.width - w), top = r.top + at(pos[1] || '50%', r.height - h);
    // what is seen of the picture: its fitted box, cut to the element (a cover crop overflows it)
    var x0 = Math.max(left, r.left), y0 = Math.max(top, r.top), x1 = Math.min(left + w, r.left + r.width), y1 = Math.min(top + h, r.top + r.height);
    if (n.left < x0 - 1 || n.right > x1 + 1 || n.top < y0 - 1 || n.bottom > y1 + 1 || n.width < 1 || n.height < 1) return null;
    var s = Math.min(1, 64 / n.width, 24 / n.height);
    return { x: (left - n.left) * s, y: (top - n.top) * s, w: w * s, h: h * s, cw: Math.ceil(n.width * s), ch: Math.ceil(n.height * s) };
  }
  // A scrim the theme lays over a picture changes what the note sits on: the heroes' gradient (::before), the dark
  // corner a left-aligned column hero lays under its title (::after, nav-landing-2310), the artwork band's tint. Each
  // is read from its own computed style at the note's middle - a flat colour, one top-to-bottom linear gradient or one
  // radial gradient of a given size - and they stack in the order they paint (z-index, then ::before before ::after):
  // on the screen a background channel shows picture * k + c. A scrim that paints over the note itself dims its
  // letters too (a note inside a rotating hero's crossfade frame lay under the gradient: white letters measured 0.31
  // there - place() now hangs it after its frame), which moves the backgrounds each tone keeps 4.5:1 on - whiteUpTo /
  // inkFrom, the relative luminance up to / from which white / ink letters reach it (WCAG (L1 + 0.05) / (L2 + 0.05);
  // 0.1833 and 0.2214 with nothing over the note). null = a scrim the read cannot work out, and the note keeps the tone
  // it has.
  // The newsletter band's ::before lies under its picture: not a scrim. The column heroes' own CSS also colours their
  // notes white on that corner (sections/collection-header-2026.liquid, 3c148df): the two agree, and the rule holds
  // in a browser that serializes the gradient in a form read here as null.
  var SCRIMS = [['.g26-hero', '::before'], ['.g26-hero', '::after'], ['.g26-finder--artwork', '::after']];
  function scrimOver(img, note, n) {
    var layers = [], x = n.left + n.width / 2, y = n.top + n.height / 2;
    for (var i = 0; i < SCRIMS.length; i++) {
      var host = img.closest(SCRIMS[i][0]);
      if (!host) continue;
      var cs = getComputedStyle(host, SCRIMS[i][1]);
      if (!cs || !cs.content || cs.content === 'none' || cs.content === 'normal' || cs.display === 'none') continue;
      var r = host.getBoundingClientRect(), o = parseFloat(cs.opacity), b = rgbaOf(cs.backgroundColor);
      var t = !cs.backgroundImage || cs.backgroundImage === 'none' ? [0, 0, 0, 0] : gradientAt(cs.backgroundImage, x - r.left, y - r.top, r.width, r.height);
      if (!b || !t) return null;
      o = isNaN(o) ? 1 : o;
      // the image over the colour, at the layer's opacity; over the note when it paints after the note's level
      var z = parseInt(cs.zIndex, 10) || 0, at = levelOf(note, host);
      layers.push({ z: z, i: i, a: (t[3] + b[3] * (1 - t[3])) * o, rgb: [0, 1, 2].map(function (j) { return (t[j] + b[j] * (1 - t[3])) * o; }),
        over: z > at || (z === at && SCRIMS[i][1] === '::after') });
    }
    layers.sort(function (p, q) { return p.z - q.z || p.i - q.i; });
    var k = 1, c = [0, 0, 0], lk = 1, lc = [0, 0, 0];
    layers.forEach(function (l) {
      for (var j = 0; j < 3; j++) { c[j] = c[j] * (1 - l.a) + l.rgb[j]; if (l.over) lc[j] = lc[j] * (1 - l.a) + l.rgb[j]; }
      k *= 1 - l.a;
      if (l.over) lk *= 1 - l.a;
    });
    var lw = lum(255 * lk + lc[0], 255 * lk + lc[1], 255 * lk + lc[2]), li = lum(INK * lk + lc[0], INK * lk + lc[1], INK * lk + lc[2]);
    return { k: k, c: c, whiteUpTo: (lw + 0.05) / 4.5 - 0.05, inkFrom: 4.5 * (li + 0.05) - 0.05 };
  }
  // the z-index the note paints at against its host's pseudo-elements: that of its outermost ancestor below the host
  // that starts a stacking context (a crossfade frame), else its own
  function levelOf(note, host) {
    var z = parseInt(getComputedStyle(note).zIndex, 10) || 0;
    for (var a = note.parentElement; a && a !== host; a = a.parentElement) {
      var s = getComputedStyle(a);
      if ((s.position !== 'static' && s.zIndex !== 'auto') || s.opacity !== '1' || s.transform !== 'none' || s.filter !== 'none' ||
        s.isolation === 'isolate' || /opacity|transform/.test(s.willChange)) z = parseInt(s.zIndex, 10) || 0;
    }
    return z;
  }
  // a computed colour as premultiplied [r, g, b, a] (the gradients mix them so); null for any other colour syntax
  function rgbaOf(s) {
    var m = /^rgba?\(([\d.]+), ([\d.]+), ([\d.]+)(?:, ([\d.]+))?\)$/.exec(String(s || '').trim());
    if (!m) return null;
    var a = m[4] === undefined ? 1 : parseFloat(m[4]);
    return [m[1] * a, m[2] * a, m[3] * a, a];
  }
  // a gradient's colour at (px, py) of its w x h box: one linear-gradient top to bottom (the computed value leaves that
  // default direction out), or one radial-gradient of a given size - an ellipse, or a circle - around a point; null
  // for anything else (more layers, another direction or shape, a colour hint, a stop in px)
  function gradientAt(im, px, py, w, h) {
    var cols = im.match(/rgba?\([^()]*\)/g) || [], m = /^(linear|radial)-gradient\(([^()]*)\)$/.exec(im.replace(/rgba?\([^()]*\)/g, 'C'));
    if (!m) return null;
    var parts = m[2].split(/\s*,\s*/), head = /^C/.test(parts[0]) ? '' : parts.shift(), t = h ? py / h : 0;
    if (m[1] === 'linear') {
      if (head && !/^(180deg|to bottom)$/.test(head)) return null;
    } else {
      var g = /^(?:(circle|ellipse) )?([\d.]+(?:px|%))(?: ([\d.]+(?:px|%)))? at (\S+) (\S+)$/.exec(head);
      if (!g) return null;   // a size keyword or none (farthest-corner) is not worked out
      var len = function (v, of) { return /%$/.test(v) ? of * parseFloat(v) / 100 : parseFloat(v); };
      var kw = { left: '0%', top: '0%', center: '50%', right: '100%', bottom: '100%' }, X = g[4], Y = g[5];
      if (/^(top|bottom)$/.test(X) || /^(left|right)$/.test(Y)) { X = g[5]; Y = g[4]; }
      var cx = len(kw[X] || X, w), cy = len(kw[Y] || Y, h), rx = g[3] ? len(g[2], w) : parseFloat(g[2]), ry = g[3] ? len(g[3], h) : rx;
      if (g[3] ? g[1] === 'circle' : g[1] === 'ellipse' || /%$/.test(g[2])) return null;   // a circle has one length, in px
      if (!(rx > 0 && ry > 0) || isNaN(cx) || isNaN(cy)) return null;
      t = Math.sqrt(Math.pow((px - cx) / rx, 2) + Math.pow((py - cy) / ry, 2));
    }
    var stops = [];
    for (var i = 0; i < parts.length; i++) {
      var s = /^C(?: (-?[\d.]+)%)?$/.exec(parts[i]), col = s && rgbaOf(cols[stops.length]);
      if (!col) return null;
      stops.push({ p: s[1] === undefined ? null : parseFloat(s[1]) / 100, c: col });
    }
    if (stops.length < 2) return null;
    // the positions CSS gives stops without one: the ends at 0 and 1, never back, the rest spread between neighbours
    if (stops[0].p === null) stops[0].p = 0;
    if (stops[stops.length - 1].p === null) stops[stops.length - 1].p = 1;
    for (var q = 1, max = stops[0].p; q < stops.length; q++) if (stops[q].p !== null) max = stops[q].p = Math.max(stops[q].p, max);
    for (q = 1; q < stops.length; q++) {
      if (stops[q].p !== null) continue;
      for (var e = q; stops[e].p === null; e++);
      for (var f = q; f < e; f++) stops[f].p = stops[q - 1].p + (stops[e].p - stops[q - 1].p) * (f - q + 1) / (e - q + 1);
    }
    if (t <= stops[0].p) return stops[0].c;
    for (q = 1; q < stops.length; q++) {
      if (t > stops[q].p) continue;
      var lo = stops[q - 1], hi = stops[q], share = hi.p > lo.p ? (t - lo.p) / (hi.p - lo.p) : 1;
      return lo.c.map(function (v, z) { return v + (hi.c[z] - v) * share; });
    }
    return stops[stops.length - 1].c;
  }
  function lum(r, g, b) { return 0.2126 * LIN[r | 0] + 0.7152 * LIN[g | 0] + 0.0722 * LIN[b | 0]; }
  // a scrim that decides alone: pure white under it still leaves white letters at 4.5:1 (the column heroes' corner),
  // or pure black under it ink ones - whatever the picture holds, so the note needs neither the list nor a read
  function scrimTone(s) {
    if (!s) return null;
    if (lum(255 * s.k + s.c[0], 255 * s.k + s.c[1], 255 * s.k + s.c[2]) <= s.whiteUpTo) return 'white';
    return lum(s.c[0], s.c[1], s.c[2]) >= s.inkFrom ? 'ink' : null;
  }
  // the tone the pixels want (SJ: white only on dark close-ups, black otherwise): white where the pixels that leave white
  // letters at 4.5:1 are at least half again as many as the ones that leave ink letters at 4.5:1, else ink - of 24
  // placements measured in both tones on 25.10.2026 this margin picked the better tone in 20 and lost the least
  // contrast (a clip poster half on a boot, half on a leg: ink 10.15:1, white 3.63:1; any margin from 1.35 to 2 gave
  // the same). A see-through pixel shows the paper-light page behind it, the scrim lies over all; nothing opaque at all
  // (a blocked readback in Chrome-likes is transparent black) is no answer. blank = every pixel pure white, which is
  // also what a browser that blocks canvas reads (Tor, Firefox resisting fingerprinting) hands out
  function verdictOf(d, s) {
    var dark = 0, light = 0, opaque = 0, white = 0, k = s.k, c = s.c;
    for (var i = 0; i < d.length; i += 4) {
      var a = d[i + 3], w = 255 - a;
      if (a) opaque++;
      if (a === 255 && d[i] === 255 && d[i + 1] === 255 && d[i + 2] === 255) white++;
      var y = lum((d[i] * a + 255 * w) / 255 * k + c[0], (d[i + 1] * a + 255 * w) / 255 * k + c[1], (d[i + 2] * a + 255 * w) / 255 * k + c[2]);
      if (y <= s.whiteUpTo) dark++; else if (y >= s.inkFrom) light++;
    }
    if (!opaque) return null;
    return { tone: dark && dark >= 1.5 * light ? 'white' : 'ink', blank: white * 4 === d.length };
  }
  // the picture drawn through a canvas the size of the note: only the part under the note lands in it (a few
  // microseconds; measured 25.10.2026)
  var canvas = null;
  function readRegion(img, g, s) {
    try {
      canvas = canvas || document.createElement('canvas');
      canvas.width = g.cw; canvas.height = g.ch;
      var x = canvas.getContext('2d', { willReadFrequently: true });
      x.drawImage(img, g.x, g.y, g.w, g.h);
      return verdictOf(x.getImageData(0, 0, g.cw, g.ch).data, s);   // getImageData throws on a tainted canvas
    } catch (e) { return null; }
  }
  function readNote(note) {
    var img = note && pictureOf(note);
    // a clip, a picture still loading (its load event asks again), a note not rendered (its resize asks again)
    if (!img || !note.isConnected || img.tagName !== 'IMG' || !img.complete || !img.naturalWidth) return;
    var n = note.getBoundingClientRect();
    if (!n.width || !n.height) return;
    var sig = sigOf(img, n), px = note.__g26Px || (note.__g26Px = {});
    if (!px[sig]) {
      var s = scrimOver(img, note, n), g = s && regionOf(img, n), v = g && readRegion(img, g, s);
      // no answer (a scrim it cannot work out, the note not wholly on the picture, a tainted or blank canvas): the
      // tone it has stays
      if (!v) return;
      if (v.blank && note.hasAttribute('data-on-dark')) return;   // pure white against a white note: likely a blocked read
      px[sig] = v.tone;
    }
    px.last = srcOf(img);
    setTone(note, px[sig]);
  }
  // reads wait for the load event and then run in idle time, a few at a time
  var waiting = [], asked = false, loaded = document.readyState === 'complete';
  var whenIdle = window.requestIdleCallback ? function (f) { window.requestIdleCallback(f, { timeout: 2000 }); }
    : function (f) { setTimeout(function () { f({ timeRemaining: function () { return 8; } }); }, 50); };
  function readSoon(note) {
    if (waiting.indexOf(note) < 0) waiting.push(note);
    if (loaded && !asked) { asked = true; whenIdle(readWaiting); }
  }
  function readWaiting(deadline) {
    asked = false;
    do { readNote(waiting.shift()); } while (waiting.length && deadline.timeRemaining() > 2);
    if (waiting.length) { asked = true; whenIdle(readWaiting); }
  }
  window.addEventListener('load', function () {
    loaded = true;
    if (waiting.length && !asked) { asked = true; whenIdle(readWaiting); }
  });

  function place(el) {
    var note = el.__g26AiNote;
    if (!note || !el.isConnected) return;
    var r = el.getBoundingClientRect();
    if (!r.width || !r.height) return;   // not rendered yet (a closed menu, a hidden lightbox): the ResizeObserver calls again
    var pic = pictureBox(el, r);
    // a card's label belongs to its picture frame, where the card's CSS puts it on the control row (beside the
    // quick-view eye, clear of the heart) - the 1px frame border and the contain letterbox are no reason to free-place it
    var frame = el.closest(CARD_FRAME) || (pic === r ? frameOf(el, r) : null);
    // a rotating hero's crossfade frame is a stacking context under the hero's gradient (z-index 0 against 1), which
    // would cover a label inside it too: the label hangs right after its frame, in the hero, over the gradient like on
    // every other picture, and its CSS fades it with the frame (snippets/ai-media-note.liquid)
    var fade = frame && frame.classList.contains('g26-hero__media--frame') && frame.parentElement;
    if (fade && !positionable(fade)) fade = null;
    var host = fade || (frame && positionable(frame) ? frame : null);
    var free = !host;
    if (free) {
      host = anchorOf(el);
      if (!host || !positionable(host)) { note.remove(); return; }   // no safe place: the marker attributes still stand
    }
    if (getComputedStyle(host).position === 'static') host.classList.add('g26-ai-frame');
    var size = sizeOf(pic.width);
    note.setAttribute('data-size', size);
    if (!free) {
      note.removeAttribute('data-place');
      note.style.left = note.style.top = note.style.width = note.style.maxWidth = '';
      if (fade ? note.previousElementSibling !== frame : note.parentElement !== host) {
        dropCopies(host.children, note);   // a slider that cloned the tile cloned its label too
        if (fade) frame.insertAdjacentElement('afterend', note); else host.appendChild(note);
      }
      tone(el);
      return;
    }
    // a picture smaller than its box: the label follows the picture's own bottom-left corner
    var ref = el.parentElement && el.parentElement.tagName === 'PICTURE' ? el.parentElement : el;
    if (note.previousElementSibling !== ref) {
      dropCopies([ref.nextElementSibling], note);
      ref.insertAdjacentElement('afterend', note);
    }
    note.setAttribute('data-place', 'free');
    var inset = size === 'l' ? 12 : 6;   // fine print sits tight in the corner on every size (22.10.2026; 16/8 before)
    note.style.width = '';
    note.style.maxWidth = (pic.width - 2 * inset) + 'px';
    var op = note.offsetParent || host, h = op.getBoundingClientRect();
    note.style.left = (pic.left - h.left - op.clientLeft + op.scrollLeft + inset) + 'px';
    note.style.top = (pic.bottom - h.top - op.clientTop + op.scrollTop - note.offsetHeight - inset) + 'px';
    tone(el);
  }

  /* ---------- labelling ---------- */
  var resize = 'ResizeObserver' in window ? new ResizeObserver(function (entries) {
    entries.forEach(function (e) { place(e.target); });
  }) : null;
  var labelled = [];

  function label(el, key) {
    el.setAttribute('data-ai-media-key', key);
    el.setAttribute('data-digital-source-type', IPTC);
    if (!el.__g26AiNote) {
      var note = document.createElement('span');
      note.className = 'g26-ai-note';
      note.setAttribute('data-ai-note', '');
      var shown = document.createElement('span');
      shown.setAttribute('aria-hidden', 'true');
      shown.textContent = SHORT;
      var told = document.createElement('span');
      told.className = 'visually-hidden';
      told.textContent = NOTE;
      note.appendChild(shown);
      note.appendChild(told);
      note.__g26Owner = el;
      el.__g26AiNote = note;
      labelled.push(el);
      if (resize) resize.observe(el);
    }
    place(el);
    listLd(el, key);
  }
  function unlabel(el) {
    el.removeAttribute('data-ai-media-key');
    el.removeAttribute('data-digital-source-type');
    if (el.__g26AiNote) el.__g26AiNote.remove();
    el.__g26AiNote = null;
    if (resize) resize.unobserve(el);
    var i = labelled.indexOf(el);
    if (i > -1) labelled.splice(i, 1);
  }
  function check(el) {
    if (!el.isConnected || el.closest(OWN_NOTE)) return;
    var key = aiKeyOf(el);
    if (key) label(el, key);
    else if (el.__g26AiNote) unlabel(el);   // a reused element now shows another picture
  }

  /* ---------- one JSON-LD list of the page's AI media ---------- */
  var ld = {}, ldOrder = [], ldEl = null;
  function listLd(el, key) {
    if (ld[key]) return;
    var url = (urlsOf(el).filter(function (u) { return keyOf(u) === key; })[0] || '').split('?')[0];
    if (!url) return;
    url = new URL(url, location.href).href;
    var video = /^[0-9a-f]{32}$/.test(key);
    ld[key] = video
      ? { '@type': 'MediaObject', contentUrl: url, encodingFormat: 'video/mp4', digitalSourceType: IPTC }
      : { '@type': 'ImageObject', contentUrl: url, digitalSourceType: IPTC };
    ldOrder.push(key);
    if (!ldEl) {
      ldEl = document.createElement('script');
      ldEl.type = 'application/ld+json';
      ldEl.id = 'g26-ai-media-ld';
      document.head.appendChild(ldEl);
    }
    ldEl.textContent = JSON.stringify({ '@context': 'https://schema.org', '@graph': ldOrder.map(function (k) { return ld[k]; }) });
  }

  /* ---------- now and later ---------- */
  var queue = [], queued = false, sweep = false;
  function schedule() {
    if (!queued) { queued = true; requestAnimationFrame(flush); }
  }
  function enqueue(el) {
    if (queue.indexOf(el) < 0) queue.push(el);
    schedule();
  }
  function flush() {
    queued = false;
    // a picture taken out of the page takes its label along (a slider that swaps the <img> keeps the frame)
    if (sweep) { sweep = false; labelled.slice().forEach(function (el) { if (!el.isConnected) unlabel(el); }); }
    var batch = queue; queue = [];
    batch.forEach(check);
  }
  function scan(root) {
    if (root.tagName === 'IMG' || root.tagName === 'VIDEO') enqueue(root);
    if (root.querySelectorAll) root.querySelectorAll('img, video').forEach(enqueue);
    // the product page's and the quick view's own notes: their first tone is theirs, the pixel read is ours
    if (root.matches && root.matches(SLIDE_NOTE)) readSoon(root);
    if (root.querySelectorAll) root.querySelectorAll(SLIDE_NOTE).forEach(readSoon);
  }
  new MutationObserver(function (records) {
    records.forEach(function (m) {
      if (m.type === 'childList') {
        if (m.removedNodes.length) { sweep = true; schedule(); }
        m.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); });
      } else {
        var t = m.target.tagName === 'SOURCE' ? m.target.parentElement : m.target;
        if (t && (t.tagName === 'IMG' || t.tagName === 'VIDEO')) enqueue(t);
      }
    });
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset', 'data-src', 'poster'] });
  // an image that picked its source (srcset, lazy) or a clip that loaded: check again with what it really shows
  ['load', 'loadedmetadata'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var t = e.target;
      if (t && (t.tagName === 'IMG' || t.tagName === 'VIDEO')) enqueue(t);
      var slideNote = t && t.tagName === 'IMG' && t.parentElement && t.parentElement.querySelector(SLIDE_NOTE);
      if (slideNote) readSoon(slideNote);   // a slide's picture that has arrived (lazy, or the quick view's)
    }, true);
  });
  // a picture that moved without changing size (text reflow above it) keeps its label in place
  var reflow = 0;
  window.addEventListener('resize', function () {
    clearTimeout(reflow);
    reflow = setTimeout(function () {
      labelled.slice().forEach(function (el) { if (el.isConnected) place(el); else unlabel(el); });
      document.querySelectorAll(SLIDE_NOTE).forEach(readSoon);   // a new size can be a new crop
    }, 150);
  });
  scan(document.body);

  window.g26AiMedia = { isAi: function (url) { var k = keyOf(url); return !!(k && KEYS[k]); }, note: NOTE };
})();
